/* eslint-disable no-unused-vars */
/* global G */
import find from 'lib/sequence/component/children/find'
import { hide, show } from 'lib/sequence/component/state/hidden'
import map from 'lib/sequence/model/api/map'
import { bulk, getFirstItem, setKey } from 'lib/util'
import asObject from 'lib/sequence/component/children/asObject'
import session from 'app/_shared/session'
import getUserRole from 'app/_shared/events/user/role'

const bulkShow = bulk(show)
const bulkHide = bulk(hide)

/**
 * OptionManagement show action
 *
 * @param {Gaia.AppModule.Spec} module  current module
 */
export default module => component => async (...args) => {
  const model = module[G.MODEL]
  const online = module[G.ADAPTER][G.SESSION][G.STATE][G.ONLINE]
  const { user } = session(module)

  const { type: { [G.CACHE]: type = 'option' } = {}, equipment } = model[G.CHILDREN]

  const machine = getFirstItem(equipment[G.CACHE])

  const actionComponent = module[G.STATE][G.ACTION][G.COMPONENT]
  const {
    box,
    serialNumber,
    passwordTitle,
    pinTitle,
    pinIcon,
    lockIcon,
    instructions,
  } = find(component)

  const actionsContainer = actionComponent[G.ACTIONS][0]
  const actions = asObject(actionsContainer[G.CHILDREN])

  const { btnSave, btnDetail } = actions

  map(model)(box)

  type === 'option'
    ? bulkShow(passwordTitle, lockIcon, btnSave, instructions)
      && bulkHide(pinTitle, pinIcon, btnDetail, serialNumber)
    : bulkShow(pinTitle, pinIcon, btnDetail, serialNumber)
      && bulkHide(passwordTitle, lockIcon, btnSave, instructions)

  const userRole = getUserRole(user.ref()?.value?.roles, module, component, null)?.key
  userRole === 'PinCreatorOnly_c' && hide(actionsContainer)

  type === 'pin'
    && !machine?._rev
    && setKey(true, online ? 'disabled' : 'disabledWhenOffline', btnDetail[G.STATE])

  return args
}
